<template>
  <BContainer>
    <BRow align-v="center">
      <BCol lg="6" class="pr-lg-5">
        <cld-image
          public-id="v1557870302/state_of_visual_media/cloudinary-slide7.svg"
          alt="Two figures conversing about media"
          fluid
        />
        <h2 class="my-4">Customer loyalty, emerging trends and word-of-mouth engagement</h2>
        <p>It’s important that both web and app platforms are optimized for your visual media—app users are a part of a brand’s loyal audience, and those customers will have access to unique features, including push notifications, deals, and more.</p>
        <v-popover popover-class="pp-20">
          <LearnMore />
          <template slot="popover">
            <div class="popover-title" style="margin: 0;">
              <cld-image
                class="tooltip-finger-icon"
                public-id="v1557870041/state_of_visual_media/cloudinary-finger.svg"
                alt="Icon of a hand with the index finger pointing up, representing a tool tip"
              />
              <p>
                Mobile app users have up to
                <strong>{{ numbers.conversion }}%</strong> higher conversion rates
              </p>
            </div>
          </template>
        </v-popover>
      </BCol>
      <BCol lg="6" class="pl-lg-5">
        <p>One technology on the cutting edge? HEIF—it enables richer and more vibrant colors, giving visual media some extra oomf.</p>
        <strong>Nearly 1/5 of all visual traffic comes from mobile app users</strong>
        <BRow class="my-3">
          <BCol cols="3">
            <ChartRing :nums="ringHeifAccess" chart-id="ringHeifAccess" />
          </BCol>
          <BCol cols="7" class="d-flex">
            <ul class="my-auto access">
              <li>
                Mobile Web
                <strong>{{ numbers["heif-access"][0] }}%</strong>
              </li>
              <li>
                Desktop
                <strong>{{ numbers["heif-access"][1] }}%</strong>
              </li>
              <li>
                Mobile App
                <strong>{{ numbers["heif-access"][2] }}%</strong>
              </li>
            </ul>
          </BCol>
        </BRow>
        <GreyBox>
          <span>E-commerce is leading the pack to deliver on visual experience</span>
        </GreyBox>
        <strong>Industries using HEIF to share visual stories</strong>
        <BRow class="my-3">
          <BCol cols="12">
            <table class="w-100">
              <tr class="bar-outer">
                <td class="bar-blue">&nbsp;</td>
                <td class="bar-grey">&nbsp;</td>
              </tr>
            </table>
          </BCol>
          <div class="w-100 mb-3"></div>
          <BCol sm="4" class="pr-0">
            <ul class="my-auto industry">
              <li class="ecommerce">
                E-commerce
                <strong>{{ numbers["heif-industry"][0] }}%</strong>
              </li>
            </ul>
          </BCol>
          <BCol sm="4">
            <ul class="industry">
              <li>
                Social
                <strong>{{ numbers["heif-industry"][1] }}%</strong>
              </li>
              <li>
                Education
                <strong>{{ numbers["heif-industry"][2] }}%</strong>
              </li>
            </ul>
          </BCol>
          <BCol sm="4">
            <ul class="my-auto industry">
              <li>
                Technology
                <strong>{{ numbers["heif-industry"][3] }}%</strong>
              </li>
              <li>
                Real Estate
                <strong>{{ numbers["heif-industry"][4] }}%</strong>
              </li>
            </ul>
          </BCol>
        </BRow>
        <div class="w-100" />
        <p>When staying on the pulse of emerging technologies, staying up to date with trending tech for commonly used browsers is also essential.</p>
        <v-popover popover-class="pp-60">
          <LearnMore />
          <template slot="popover">
            <div class="popover-title" style="margin: 0;">
              <cld-image class="tooltip-finger-icon" public-id="v1557870041/state_of_visual_media/cloudinary-finger.svg" alt="Icon of a hand with the index finger pointing up, representing a tool tip" />
              <strong>Advanced visual codecs technology with Safari</strong>
            </div>
            <div class="ml-4 mt-3">
              <div class="w-75">
                <cld-image
                  class="my-3"
                  fluid
                  public-id="v1560918328/state_of_visual_media/cloudinary-codec-quantogram.svg"
                  alt="Quantagram showing 9 of 10 circles"
                />
              </div>
              <p>HEVC: <strong>9 in 10</strong></p>
              <strong class="d-block mt-5">Advanced visual codecs technology with Chrome</strong>
              <div class="w-75">
                <cld-image
                  class="my-3"
                  fluid
                  public-id="v1560918302/state_of_visual_media/cloudinary-quant6.svg"
                  alt="Quantagram showing 6 of 10 circles"
                />
              </div>
              <p>VP9: <strong>6 in 10</strong></p>
              <div class="w-75">
                <cld-image
                  class="my-3"
                  fluid
                  public-id="v1560918259/state_of_visual_media/cloudinary-quant3.svg"
                  alt="Quantagram showing 3 of 10 circles"
                />
              </div>
              <p>AV1: <strong>3 in 10</strong></p>
            </div>
          </template>
        </v-popover>
      </BCol>
    </BRow>
    <footer class="w-md-50">
      <p class="small">Sources: Fast Company, Harvard Study of Communications, Carleton University, Human-Oriented Technology Lab</p>
    </footer>
  </BContainer>
</template>

<script>
import LearnMore from "../LearnMore.vue";
import GreyBox from "../greybox.vue";
import ChartRing from "../donut-ring.vue";
// import ChartDonut from "../donut-filled.vue";

export default {
  components: {
    LearnMore,
    GreyBox,
    ChartRing,
    // ChartDonut
  },
  props: {
    numbers: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    ringHeifAccess() {
      return {
        data: this.numbers["heif-access"],
        backgroundColor: ["#0091ff", "#f4b21b", "#B5B5B6"],
        labels: ["Mobile Web", "Desktop", "Mobile App"]
      };
    },
    ringHeifIndustry() {
      return {
        data: this.numbers["heif-industry"],
        backgroundColor: ["#0091ff", "#a6a8ab", "#bbbdbf", "#d0d2d3", "#e6e7e8"]
      };
    }
  }
};
</script>

<style lang="scss" scoped>
aside {
  &:before {
    @include triangle(bottom, $lightgrey, 8px);
    position: absolute;
    left: 20%;
    top: 100%;
  }
}
ul {
  list-style: none;
  margin: 0;
  padding: 0;
  li {
    &:before {
      $dim: 12px;
      height: $dim;
      width: $dim;
      display: inline-block;
      content: "";
    }
  }
  &.access {
    li {
      &:nth-of-type(1):before {
        background: $blue;
      }
      &:nth-of-type(2):before {
        background: $gold;
      }
      &:nth-of-type(3):before {
        background: #B5B5B6;
      }
    }
  }
  &.industry {
    li {
      &.ecommerce {
        &:before {
          background: $blue;
        }
      }
      &:before {
        background: $darkgrey;
      }
    }
  }
}
.bar-outer {
  width: 100%;
  height: 1em;

  .bar-blue {
    width: 98.3%;
    background: $blue;
  }
  .bar-grey {
    background: $darkgrey;
  }
}
</style>
